import { Location } from 'graphql/generated/graphqlTypes';
import { locationsWithDoorsVar } from 'state/vars';

export const setLocationsWithDoorsAction = (locations: Location[]) => {
  locationsWithDoorsVar(locations);
};

export const addLocationsWithDoorsAction = (location: Location) => {
  const currentLocationsWithDoors = locationsWithDoorsVar();
  const updatedLocationsWithDoors = [...currentLocationsWithDoors, location];

  locationsWithDoorsVar(updatedLocationsWithDoors);
};

export const updateLocationsWithDoorsAction = (location: Location) => {
  const currentLocationsWithDoors = locationsWithDoorsVar();
  const updatedLocationsWithDoors = currentLocationsWithDoors.map((group) =>
    group.id === location.id ? location : group
  );

  locationsWithDoorsVar(updatedLocationsWithDoors);
};

export const deleteLocationsWithDoorsAction = (locationId: string) => {
  const currentLocationsWithDoors = locationsWithDoorsVar();
  const updatedLocationsWithDoors = currentLocationsWithDoors.filter((group) => group.id !== locationId);

  locationsWithDoorsVar(updatedLocationsWithDoors);
};
